export interface WalkThroughStep {
  name: string;
  heading: string;
  tooltipPosition: WalkThroughTooltipPosition;
  route?: string;
}

export enum WalkThroughTooltipPosition {
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
  BottomMiddle = 'bottom-middle',
  TopLeft = 'top-left',
  TopRight = 'top-right',
  TopMiddle = 'top-middle',
  LeftBottom = 'left-bottom',
  RightBottom = 'right-bottom',
}

export const WalkThroughStepsList: WalkThroughStep[] = [
  {
    name: 'addSite',
    heading: 'Add your site here or upload a CSV file',
    route: '/widget',
    tooltipPosition: WalkThroughTooltipPosition.BottomLeft,
  },
  {
    name: 'clickSite',
    heading: 'Click here to customize your widget',
    route: '/widget',
    tooltipPosition: WalkThroughTooltipPosition.TopLeft,
  },
  // {
  //   name: 'notifications',
  //   heading: 'To view all notifications, go here',
  //   tooltipPosition: WalkThroughTooltipPosition.BottomLeft,
  // },
  {
    name: 'search',
    heading: 'To quickly search your sites, go here',
    tooltipPosition: WalkThroughTooltipPosition.BottomLeft,
  },
  {
    name: 'settings',
    heading: 'General settings and billing',
    tooltipPosition: WalkThroughTooltipPosition.BottomLeft,
  },
  {
    name: 'imgAlts',
    heading: 'Update your image alts now',
    tooltipPosition: WalkThroughTooltipPosition.TopRight,
  },
];
